import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ScrollService {
  private scrollMainTopSubject = new Subject<void>();
  scrollMainTop$ = this.scrollMainTopSubject.asObservable();

  requestScrollMainTop(): void {
    this.scrollMainTopSubject.next();
  }
}
